export const initConversationUseTheApp = () => {
  const alertUseTheApp = document.getElementById("alert-use-the-app") as HTMLDivElement;

  if (!alertUseTheApp) {
    return;
  }

  alertUseTheApp.addEventListener("closed.bs.alert", () => {
    const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");

    // biome-ignore lint/suspicious/noDocumentCookie: <Fix after all files will be refactored to biome rules>
    document.cookie =
      "alert_use_the_app=true; max-age=2592000; path=/; domain=" +
      hostnameBase +
      "; secure; samesite=lax";
  });
};
